import React from "react";
import "./ErrorPage.scss";
const ErrorPage = () => {
  return (
    <div className="errorPageContainer">
      <div className="errorPageWrapper">
        <h2>404 Page Not Found</h2>
      </div>
    </div>
  );
};

export default ErrorPage;
